import {
  AnalyticsCoursesList,
  AnalyticsCoursesSummary
} from '.';

const AnalyticsCourses = () => (
  <div className="courses">
    <AnalyticsCoursesSummary />

    <AnalyticsCoursesList />
  </div>
);

export default AnalyticsCourses;
